import SupplementController from '../common/supplement_controller'

// 実装は PC/SP 共通（common/supplement_controller.js）。
// 差分はSCSSの寸法のみなので、ここでは識別子の登録のためだけに継承する。
export default class extends SupplementController {}
